export enum ContentViewState {
    UserQuery,
    Loader,
    Error,
}
